// extracted by mini-css-extract-plugin
export var tosLink = "_42-0";